import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectionOption } from '@core/models';
import { EmployeeRole } from '@core/models/role-admin/employee-role.model';
import { LayoutService } from '@core/services';
import { RoleAdminService } from '@core/services/role-admin.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'app-add-employee-to-role',
    templateUrl: './add-employee-to-role.component.html',
    styleUrls: ['./add-employee-to-role.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddEmployeeToRoleComponent implements OnInit {
  static readonly componentName = 'AddEmployeeToRoleComponent';
  
  selectedEmployee: FormControl<number>;
  isSubmitting$: Subject<boolean>;
  public isMobile$: Observable<boolean>;

  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { options: SelectionOption[]; sysText: any; roleId: string },
    private service: RoleAdminService,
    private dialogRef: MatDialogRef<AddEmployeeToRoleComponent>,
    private layoutService: LayoutService
  ) {
    this.selectedEmployee = new FormControl(null, Validators.required);

    this.isSubmitting$ = new Subject();
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
  }

  onSubmit() {
    const eRole: EmployeeRole = {
      eeId: this.selectedEmployee.value,
      roleId: this.data.roleId
    };
    this.service
      .addEmployeeRole(eRole)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.dialogRef)
      )
      .subscribe(() => {
        this.dialogRef.close(eRole);
      });
  }
}
